module.exports = __webpack_public_path__ + "static/media/region-guidelines.0a4e5e15.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/general/region-guidelines.pdf
// module id = 210
// module chunks = 0